export const CREATE_MODES = {
  MANUAL: 'manual',
  WITH_AI: 'ai'
};
export const VARIANT_PANEL_STEPS = {
  CONTENT_TYPE: 'CONTENT_TYPE',
  VARIANT_FORM: 'VARIANT_FORM'
};
export const IMAGE_GEN_MODES = {
  GENERATE: 'generate',
  USE_EXISTING: 'useExisting'
};